<template>
  <div class="calendar-scroll-month-selector">
    <div
      ref="header"
      class="booking-header-extension"
    >
      <header-close :back="close" />
      <div class="booking-header-title">
        {{ tc('booking.selectMonth') }}
      </div>
    </div>
    <div
      class="calendar-scroll-month-list"
      :style="[
        { height: scrollHeight ? scrollHeight + 'px' : 'auto'}
      ]"
    >
      <ul class="form">
        <li
          v-for="month in monthsRendered"
          :key="`${month.month}`"
          class="option"
          :class="{'is-hidden': isHidden(getMonthFormat(month.month))}"
        >
          <input
            :id="'input-' + month.month"
            :key="getMonthFormat(month.month)"
            v-model="selectedMonth"
            type="radio"
            name="selectedMonth"
            :disabled="isDisabled(getMonthFormat(month.month))"
            :value="getMonthFormat(month.month)"
            :checked="getMonthFormat(month.month)"
          >
          <label
            :for="'input-' + month.month"
            :class="[{ disabled: isDisabled(getMonthFormat(month.month)) }]"
            :tabindex="isDisabled(getMonthFormat(month.month)) ? '-1': '0'"
            @click="handleClick(month.month)"
            @keydown.space.prevent="handleClick(month.month)"
            @keydown.enter.prevent="handleClick(month.month)"
          >
            <div class="month-button-container">
              <span class="label-text">{{ tc(`calendar.months.${parseInt(month.month.slice(0, 2), 10)}`) }} {{ month.month.split('-')[1] }}</span>
              <span class="icon-checkmark" />
            </div>
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { getDate } from '@utils/date-helpers'
  import TabTrapMixin from '@mixins/tab-trap'
  import HeaderClose from '../../header-close/header-close.vue'

  export default {
    name: 'CalendarMonthSelector',
    components: {
      HeaderClose
    },
    mixins: [TabTrapMixin],
    props: {
      monthInDate: {
        type: Object,
        required: true
      },
      monthsRendered: {
        type: Array,
        default: []
      }
    },
    data: () => ({
      currentYear: null,
      selectedMonth: null,
      scrollHeight: null,
    }),
    computed: {
      ...mapState('booking', ['now']),
      ...mapGetters('booking', ['monthFormat']),
      ...mapGetters('i18n', ['tc']),
      ...mapState('responsive', { wHeight: 'height', wWidth: 'width' }),
      thisMonth() {
        return this.now.format(this.monthFormat)
      },
      lastMonth() {
        return getDate(this.now).add(12, 'month').format(this.monthFormat)
      },
      monthList() {
        return []
      }
    },
    watch: {
      wWidth() {
        this.calculateHeight()
      },
      firstFocusableEl(val) {
        if (val) {
          this.firstFocusableEl.focus()
        }
      },
    },
    created() {
      this.selectedMonth = this.monthInDate.format(this.monthFormat)
    },
    mounted() {
      this.calculateHeight()
    },
    methods: {
      calculateHeight() {
        const headerHeight = this.$refs.header.getBoundingClientRect().height
        this.scrollHeight = this.wHeight - headerHeight
      },
      getMonthFormat(month) {
        return getDate(`${month}`, 'M-YYYY').format(this.monthFormat)
      },
      close() {
        this.$emit('close')
      },
      isHidden(month) {
        const monthInDate = getDate(month, this.monthFormat)
        return monthInDate.isBefore(
          getDate(this.thisMonth, this.monthFormat), 'month'
        )
      },
      isDisabled(month) {
        const monthInDate = getDate(month, this.monthFormat)
        return monthInDate.isAfter(
          getDate(this.lastMonth, this.monthFormat), 'month'
        )
      },
      handleClick(month) {
        const monthFormatted = this.getMonthFormat(month)
        if (this.selectedMonth === monthFormatted) {
          this.$emit('close')
        } else {
          this.selectedMonth = monthFormatted
          this.$emit('select-month', this.selectedMonth)
        }
      }
    }
  }
</script>
